import { configureStore } from '@reduxjs/toolkit';
import transactionSlice from './slices/transactionSlice';
import budgetSlice from './slices/budgetSlice';
import goalSlice from './slices/goalSlice';
import notificationSlice from './slices/notificationSlice';
import analyticsSlice from './slices/analyticsSlice';
import authSlice from './slices/authSlice';

export const store = configureStore({
  reducer: {
    transactions: transactionSlice,
    budgets: budgetSlice,
    goals: goalSlice,
    notifications: notificationSlice,
    analytics: analyticsSlice,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// TypeScript types would go here if using TypeScript
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch; 